import React, { useMemo } from "react";
import danger_image from "../img/danger.png";
import no_danger_image from "../img/no_danger.png";

const AlertCellRenderer = (props) => {
  const imageForAlert = (alert) => {
    if(alert) return danger_image;
    else return no_danger_image;
  }

  const danger = useMemo(() => imageForAlert(props.value), [props.value]);

  return (
    <div className="colour-renderer">
      <img width="20px" src={danger} alt="danger"/>
    </div>
  );
};


export default AlertCellRenderer;
